export { monitorForTextSelection, dropTargetForTextSelection } from '../../adapter/text-selection-adapter';

// Payload for the text selection being dragged